import axios from "axios";

export function nextSongReviewAPI() {

  const metaData = {
    withCredentials: true,
  };

  return new Promise((resolve) => {
      axios
        .get(`${process.env.REACT_APP_BACKEND}/review/next/song`, metaData)
        .then((response) => {
          resolve(response.data);
        })
        .catch((e) => {
          resolve(e.status);
        });
    });
}